import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Row, Column, Item } from '@mui-treasury/components/flex';
import Imagen1 from '../../img/unlock-1.1s-100px.svg'
import Imagen2 from '../../img/Clock-7.1s-100px.svg'
import Imagen3 from '../../img/a-1.1s-128px.svg'
import { Grid, Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import FirebaseContext from "../../firebase/context";


const useBasicProfileStyles = makeStyles(({ palette }) => ({
    avatar: {
        borderRadius: 8,
        backgroundColor: '#495869',
    },
    overline: {
        fontSize: 20,
        textTransform: 'uppercase',
        letterSpacing: 1,
        color: '#29588F',
    },
    name: {
        fontSize: 24,
        fontWeight: 500,
        color: '#EF1927',
    },
    card: {
        border: '2px solid',
        borderColor: '#ffffff',
        background: '#ffffff',
        borderRadius: 16,
        transition: '0.4s',
        boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
        '&:hover': {
            borderColor: '#29588F',
        },
    },
    imagen: {
        borderRadius: 16,

    },
}));
const useStyles = makeStyles({
    table: {
        minWidth: 700,
    },
});


const CompAdminExamenConfg = (props) => {
    const styles = useBasicProfileStyles();
    const classes = useStyles();
    const gap = { xs: 1, sm: 1.5, lg: 2 };
    const { firebase, user } = React.useContext(FirebaseContext);
    const estado = props.item.cEstado 

    const seleccionarExamen = () => {
        const examenId = props.item.id
        props.history.push(`/examen/${examenId}`);
    }

    const editExamen = estado => {
        const editExamen = { ...props.item }
        console.log('editExamen');
        console.log(editExamen);

        editExamen.cEstado = estado
        firebase.db.collection("colExamenes").doc(props.item.id).set(editExamen, { merge: true });
        props.setExamenUpdate(true)
    }

    return (
        <Grid container spacing={4} justify={'center'}>
            <Grid item xs={12} sm={6} lg={6}>
                <Row className={styles.card} p={{ xs: 0.5, sm: 0.75, lg: 1 }} gap={gap}>

                    {
                        estado == 1 ? (
                            <Column>
                                <Row >
                                    <Item><img src={Imagen1} alt="" className={styles.imagen} /></Item>
                                    <Item position={'middle'} pl={{ sm: 0.5, lg: 0.5 }}>
                                        <Typography className={styles.overline}>{props.item.aTituloExamen}</Typography>
                                        <Typography className={styles.name}>{props.item.bFechaExamen}</Typography>
                                        <Typography className={styles.overline}>{props.item.cEstado}</Typography>
                                    </Item>
                                    <Item position={'right'} mr={-0.5}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(1)}
                                        >
                                            Desactivar
                                 </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(2)}
                                        >
                                            Iniciar
                                 </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(3)}
                                        >
                                            Terminar
                                 </Button>
                                    </Item>
                                </Row>
                            </Column>
                        ) : null
                    }


{
                        estado == 2 ? (
                            <Column>
                                <Row >
                                    <Item><img src={Imagen2} alt="" className={styles.imagen} /></Item>
                                    <Item position={'middle'} pl={{ sm: 0.5, lg: 0.5 }}>
                                        <Typography className={styles.overline}>{props.item.aTituloExamen}</Typography>
                                        <Typography className={styles.name}>{props.item.bFechaExamen}</Typography>
                                        <Typography className={styles.overline}>{props.item.cEstado}</Typography>
                                    </Item>
                                    <Item position={'right'} mr={-0.5}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(1)}
                                        >
                                            Desactivar
                                 </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(2)}
                                        >
                                            Iniciar
                                 </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(3)}
                                        >
                                            Terminar
                                 </Button>
                                    </Item>
                                </Row>
                            </Column>
                        ) : null
                    }


{
                        estado == 3 ? (
                            <Column>
                                <Row >
                                    <Item><img src={Imagen3} alt="" className={styles.imagen} /></Item>
                                    <Item position={'middle'} pl={{ sm: 0.5, lg: 0.5 }}>
                                        <Typography className={styles.overline}>{props.item.aTituloExamen}</Typography>
                                        <Typography className={styles.name}>{props.item.bFechaExamen}</Typography>
                                        <Typography className={styles.overline}>{props.item.cEstado}</Typography>
                                    </Item>
                                    <Item position={'right'} mr={-0.5}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(1)}
                                        >
                                            Desactivar
                                 </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(2)}
                                        >
                                            Iniciar
                                 </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            // startIcon={<DeleteIcon />}
                                            onClick={() => editExamen(3)}
                                        >
                                            Terminar
                                 </Button>
                                    </Item>
                                </Row>
                            </Column>
                        ) : null
                    }

                </Row>
            </Grid>
        </Grid>
    );
}

export default withRouter(CompAdminExamenConfg)
